import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Über uns",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, FederalMinistryGermanyLogo, LinkBlock, Title} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!FederalMinistryGermanyLogo) _missingMdxReference("FederalMinistryGermanyLogo", true);
  if (!LinkBlock) _missingMdxReference("LinkBlock", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "Über uns"
    }), "\n", _jsx(_components.h2, {
      id: "scope",
      children: "SCOPE"
    }), "\n", _jsx(_components.p, {
      children: "Diese Website vereint administrative Daten, Haushaltsbefragungen, Lern-Assessments und Angaben zur Bildungsfinanzierung aus mehreren Quellen, insbesondere des UNESCO-Instituts für Statistik, um die Fortschritte auf dem Weg zur Erreichung von SDG4 – des globalen Bildungsziels – zu beleuchten."
    }), "\n", _jsxs(_components.p, {
      children: ["Die Website ergänzt die ", _jsx(_components.a, {
        href: "https://en.unesco.org/gem-report/allreports",
        children: "Druckfassung"
      }), " des Weltbildungsberichts und ermöglicht es Nutzerinnen und Nutzern, mit den Daten zu interagieren, um besser zu verstehen, was Länder und Regionen bereits erreicht haben und vor welchen Herausforderungen sie auf dem Weg zur Erreichung der Ziele stehen. Die Inhalte können geteilt und heruntergeladen werden, Nutzerinnen und Nutzer können Grafiken und Dateien erstellen, um sich eingehender mit den Themen zu befassen, und diese ausdrucken beziehungsweise online oder in Präsentationen verwenden."]
    }), "\n", _jsx(_components.h2, {
      id: "über-den-weltbildungsbericht-global-education-monitoring-report",
      children: "Über den Weltbildungsbericht Global Education Monitoring Report"
    }), "\n", _jsxs(_components.p, {
      children: ["Der Weltbildungsbericht ist ein redaktionell unabhängiger jährlicher Bericht, der durch die UNESCO unterstützt und veröffentlicht wird. Laut ", _jsx(_components.a, {
        href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656",
        children: "Aktionsrahmen zur Bildungsagenda 2030"
      }), ", hat er den Auftrag, Bildungsfortschritte im Bereich der Ziele für nachhaltige Entwicklung (SDGs) sowie Entwicklungen bei der Umsetzung nationaler und internationaler Bildungsstrategien zu überwachen und so dazu beizutragen, alle beteiligten Partner bezüglich ihrer Verpflichtungen zur Rechenschaft zu ziehen."]
    }), "\n", _jsx(LinkBlock, {
      title: "Website ansehen",
      url: "https://en.unesco.org/gem-report/",
      variant: "gem"
    }), "\n", _jsx(_components.h2, {
      id: "über-das-ziel-für-nachhaltige-entwicklung-sdg-4",
      children: "Über das Ziel für nachhaltige Entwicklung SDG 4"
    }), "\n", _jsxs(_components.p, {
      children: ["Auf dem Weltgipfel für nachhaltige Entwicklung der Vereinten Nationen nahmen die Mitgliedsstaaten im September 2105 die ", _jsx(_components.a, {
        href: "https://sustainabledevelopment.un.org/post2015/transformingourworld",
        children: "Agenda 2030 für nachhaltige Entwicklung"
      }), " formal an. Diese Agenda enthält 17 Ziele für nachhaltige Entwicklung (Sustainable Development Goals, SDGs), darunter SDG 4: „Inklusive, gleichberechtigte und hochwertige Bildung gewährleisten und Möglichkeiten lebenslangen Lernens für alle fördern“. Zu diesem Ziel bestehen sieben Unterziele und drei Implementierungsmechanismen."]
    }), "\n", _jsx(LinkBlock, {
      title: " Die Unterziele und damit zusammenhängende Monitoring-Rahmen",
      url: "https://sustainabledevelopment.un.org/sdg4",
      variant: "sdg4"
    }), "\n", _jsx(FederalMinistryGermanyLogo, {
      lang: "de"
    }), "\n", _jsx(_components.p, {
      children: "Besonderer Dank gilt dem deutschen Bundesministerium für Bildung und Forschung für seine Partnerschaft und großzügige Unterstützung zur Entwicklung der Website Education Progress."
    }), "\n", _jsxs(Aside, {
      children: [_jsx(_components.h2, {
        id: "kontakt",
        children: "Kontakt"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Allgemeine E-Mail"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "mailto:gemreport@unesco.org",
          children: "gemreport@unesco.org"
        })
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Das Team"
      }), _jsx(_components.p, {
        children: "GEM Report Team, UNESCO"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Unsere Anschrift"
      }), _jsx(_components.p, {
        children: "Global Education Monitoring Report Team (GEM Report),\nUNESCO, 7 place de Fontenoy, 75352 Paris 07 SP, France"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
